import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/app/App";
import { installStaleBundleRecovery } from "@/core/utils/stale-bundle";

import "@/styles/index.css";

// Registered before the first render so a tab left open across a deploy
// recovers on its own rather than dead-ending on a missing chunk.
installStaleBundleRecovery();

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element #root not found — check index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
